import {
  Categorization,
  Category,
  UISchemaElement,
  isCategorization,
  isCategory,
} from "@jsonforms/core";

export function parseUISchemaWithElements(
  uischema: unknown
): SchemaWithElements | undefined {
  if (!isUiSchemaWithElements(uischema)) {
    return undefined;
  }

  return uischema;
}

export function isUISchemaElement(
  uischema: unknown
): uischema is UISchemaElement {
  return (
    typeof uischema === "object" &&
    (uischema as UISchemaElement).type !== undefined
  );
}

export interface ApplicationSchema extends Omit<Categorization, "elements"> {
  elements: readonly SectionSchema[];
}

export function isApplicationSchema(
  uischema: unknown
): uischema is ApplicationSchema {
  if (!isUISchemaElement(uischema)) {
    return false;
  }

  if (!isCategorization(uischema)) {
    return false;
  }

  if (!parseUISchemaWithElements(uischema)) {
    return false;
  }

  return uischema.elements.every((element) => {
    return (element as SectionSchema).name !== undefined;
  });
}

export interface SchemaWithElements extends Omit<UISchemaElement, "type"> {
  type: string;
  elements?: readonly SectionSchema[];
}
export function isUiSchemaWithElements(
  uischema: unknown
): uischema is SchemaWithElements {
  if (!isUISchemaElement(uischema)) {
    return false;
  }

  const castedUiSchema = uischema as SchemaWithElements;
  if (castedUiSchema.elements === undefined) {
    return true;
  }

  if (!Array.isArray(castedUiSchema.elements)) {
    return false;
  }

  return castedUiSchema.elements.every((element) => {
    return (element as SectionSchema).name !== undefined;
  });
}

export interface SectionSchema extends Omit<Category, "type"> {
  name: string;
  type: string;
}

export function isSectionSchema(uischema: unknown): uischema is SectionSchema {
  if (!isUISchemaElement(uischema)) {
    return false;
  }

  if (!isCategory(uischema)) {
    return false;
  }

  return (uischema as SectionSchema).name !== undefined;
}
